import { Link } from "react-router-dom";
import { channels } from "../../mocks/chigua";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-primary-50">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center gap-2.5" aria-label="今天吃瓜 首页">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
              瓜
            </span>
            <span className="font-heading text-xl font-black tracking-wide">今天吃瓜</span>
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-primary-100/80">
            今日爆料 · 吃瓜合集 · 最新瓜速览。聚合全网娱乐八卦与社会热点，帮你第一时间掌握「今天有什么新瓜」。
          </p>
          <div className="mt-5 flex items-center gap-2 text-sm text-primary-100/80">
            <i className="ri-mail-line" aria-hidden="true" />
            <a href="mailto:gossip@jintianchigua.com" className="hover:text-background-50">
              gossip@jintianchigua.com
            </a>
          </div>
        </div>

        <nav aria-label="栏目导航">
          <h3 className="font-heading text-base font-bold text-background-50">吃瓜频道</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-primary-100/85">
            {channels.map((c) => (
              <li key={c.key}>
                <Link to={`/baoliao?channel=${c.key}`} className="inline-flex items-center gap-2 hover:text-accent-300">
                  <i className={c.icon} aria-hidden="true" />
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="站内导航">
          <h3 className="font-heading text-base font-bold text-background-50">快速直达</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-primary-100/85">
            <li><Link to="/" className="hover:text-accent-300">首页热榜</Link></li>
            <li><Link to="/baoliao" className="hover:text-accent-300">吃瓜爆料库</Link></li>
            <li><Link to="/about" className="hover:text-accent-300">关于我们</Link></li>
            <li><Link to="/faq" className="hover:text-accent-300">常见问题</Link></li>
            <li><Link to="/contact" className="hover:text-accent-300">投稿与报料</Link></li>
          </ul>
        </nav>

        <div>
          <h3 className="font-heading text-base font-bold text-background-50">理性吃瓜小贴士</h3>
          <p className="mt-4 text-sm leading-relaxed text-primary-100/80">
            本站内容均为对公开网络热议信息的整理呈现，未经证实的信息仅供参考，请勿过度解读或进行人身攻击。
          </p>
          <div className="mt-4 flex items-center gap-2 text-sm">
            <span className="rounded-full bg-background-50/10 px-3 py-1">吃瓜有度</span>
            <span className="rounded-full bg-background-50/10 px-3 py-1">先看后议</span>
            <span className="rounded-full bg-background-50/10 px-3 py-1">理性追瓜</span>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-100/15">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-100/70 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 今天吃瓜 · 今日吃瓜爆料速览。内容来自网络公开信息整理，请理性看待。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-accent-400" aria-hidden="true" />
            吃瓜不停，理性不止
          </p>
        </div>
      </div>
    </footer>
  );
}